import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';

import { TSegmentThumbnail } from '../types';

import { videoThumbnailsQueryKeys } from './query-keys';

export type { TSegmentThumbnail };

export async function getSegmentThumbnails(segmentId: string): Promise<TSegmentThumbnail[]> {
  const result: any = await mediaManagerClient.get(`/api/v1/segments/${segmentId}/thumbnails`);
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.thumbnails)) return result.thumbnails;
  if (Array.isArray(result?.data)) return result.data;
  return [];
}

type QueryFnType = typeof getSegmentThumbnails;

interface UseSegmentThumbnailsParams {
  segmentId?: string;
  config?: QueryConfig<QueryFnType>;
}

export function useGetSegmentThumbnails({ segmentId, config }: UseSegmentThumbnailsParams) {
  return useQuery({
    ...config,
    enabled: !!segmentId,
    queryKey: videoThumbnailsQueryKeys.segmentThumbnails(segmentId ?? ''),
    queryFn: () => getSegmentThumbnails(segmentId!),
  });
}
